import React, { useState } from 'react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import keycloak from './keycloak';
import PrivateRoute from './PrivateRoute';
import LoginPage from './components/LoginPage';
import Kanban from './components/Kanban';
import Loading from './components/Loading';

function App() {
  const [keycloakInitialized, setKeycloakInitialized] = useState(false);

  const handleOnEvent = (event) => {
    if (event === 'onReady') {
      setKeycloakInitialized(true);
    }
  };

  const getBasename = () => {
    const pathParts = window.location.pathname.split('/');
    return pathParts.slice(0, 4).join('/');
  };
  

  return (
    <ReactKeycloakProvider authClient={keycloak} onEvent={handleOnEvent}>
      {keycloakInitialized ? (
        <Router>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/dashboard" element={<PrivateRoute component={Kanban} />} />
          </Routes>
        </Router>
      ) : (
        <Loading />
      )}
    </ReactKeycloakProvider>
  );
}

export default App;
